import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { browserHistory } from './history';
import { RouterHistory } from '@sentry/react/dist/reactrouter';

interface SentryUser {
  id: string;
  email: string;
}

export const initSentry = () => {
  process.env.REACT_APP_SENTRY_DSN &&
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
      release: `contribute-to-creator-dashboard@${process.env.REACT_APP_SENTRY_APP_VERSION}`,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(
            browserHistory as unknown as RouterHistory
          ),
        }),
      ],
    });
};

export const setSentryUser = (user: SentryUser) => {
  process.env.REACT_APP_SENTRY_DSN && Sentry.setUser(user);
};

export const clearSentryUser = () => {
  process.env.REACT_APP_SENTRY_DSN &&
    Sentry.configureScope((scope: any) => scope.setUser(null));
};
